module.exports = __webpack_public_path__ + "img/CovidSector_Infographics_23.7d3ee9a3.png";